import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SkillsCheckQandAActionTypes } from "src/app/constants/StoreConstants";
import { SetStateSuccess } from "./skills-check-q-and-a.action";

@Injectable()

export class SkillsCheckQandAEffects {
	constructor(
		private action$: Actions
	){}
	
	public setStateEffect$ = createEffect(():Observable<Action> => {
		return this.action$.pipe(
				ofType(SkillsCheckQandAActionTypes.SetState),
				map(() => {
						return SetStateSuccess();
				})				
		)
	});

}